module.exports = __webpack_public_path__ + "static/media/about-img-three.5de9f483.svg";